import { Typography, TypographyProps } from "@material-ui/core";
import { useEffect, useMemo, useState } from "react";

export type TimezoneAwareClockProps = {
  formatOpts: {
    locale: string;
    timeZone: string;
  };
} & TypographyProps;
export default function TimezoneAwareClock(props: TimezoneAwareClockProps) {
  const {
    formatOpts: { locale, timeZone },
    ...typographyProps
  } = props;

  const [dt, setDt] = useState(new Date());

  const visualDate = useMemo(() => {
    return dt.toLocaleTimeString(locale, { timeZone });
  }, [dt, locale, timeZone]);

  useEffect(() => {
    const i = setInterval(() => {
      setDt(new Date());
    }, 1000);

    return () => clearInterval(i);
  }, []);

  return (
    <Typography
      style={{
        fontFamily: "monospace",
      }}
      {...typographyProps}
    >
      {visualDate}
    </Typography>
  );
}
